/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregationResultDto } from '../../models/aggregation-result-dto';

export interface DashboardMachineClassificationsByMonthGet$Params {
  fromDate?: string;
  toDate?: string;
}

export function dashboardMachineClassificationsByMonthGet(http: HttpClient, rootUrl: string, params?: DashboardMachineClassificationsByMonthGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregationResultDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardMachineClassificationsByMonthGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AggregationResultDto>>;
    })
  );
}

dashboardMachineClassificationsByMonthGet.PATH = '/Dashboard/machine-classifications-by-month';
